const state={
    "AndamanandNicobarIslands":"Andaman and Nicobar Islands",
    "AndhraPradesh":"Andhra Pradesh",
    "ArunachalPradesh":"Arunachal Pradesh",
    "Assam":"Assam",
    "Bihar":"Bihar",
    "Chandigarh":"Chandigarh",
    "Chhattisgarh":"Chhattisgarh",
    "DadraandNagarHaveli":"Dadra and Nagar Haveli",
    "DamanandDiu":"Daman and Diu",
    "Delhi":"Delhi",
    "Goa":"Goa",
    "Gujarat":"Gujarat",
    "Haryana":"Haryana",
    "HimachalPradesh":"Himachal Pradesh",
    "JammuandKashmir":"Jammu and Kashmir",
    "Jharkhand":"Jharkhand",
    "Karnataka":"Karnataka",
    "Kerala":"Kerala",
    "Ladakh":"Ladakh",
    "Lakshadweep":"Lakshadweep",
    "MadhyaPradesh":"Madhya Pradesh",
    "Maharashtra":"Maharashtra",
    "Manipur":"Manipur",
    "Meghalaya":"Meghalaya",
    "Mapizoram":"Mapizoram",
    "Nagaland":"Nagaland",
    "Odisha":"Odisha",
    "Puducherry":"Puducherry",
    "Punjab":"Punjab",
    "Rajasthan":"Rajasthan",
    "Sikkim":"Sikkim",
    "TamilNadu":"Tamil Nadu",
    "Telangana":"Telangana",
    "Tripura":"Tripura",
    "UttarPradesh":"Uttar Pradesh",
    "Uttarakhand":"Uttarakhand",
    "WestBengal":"West Bengal"
    }
    export default state